import { differenceInHours } from 'date-fns';
export function isOrganisationOffline(organisation) {
    if (!organisation?.lastActivityAt)
        return null;
    const lastActivity = new Date(organisation.lastActivityAt);
    const now = new Date();
    const diff = differenceInHours(now, lastActivity);
    return diff >= 24;
}
//# sourceMappingURL=organisations.js.map